import { CryptographySystem_getInstance4e2ihcoisse as CryptographySystem_getInstance } from '../../../../../../cryptography-kotlin-cryptography-core/dev/whyoleg/cryptography/CryptographySystem.mjs';
import { get_defaultProvider1a56q6a181l5h as get_defaultProvider } from './WebCryptoCryptographyProvider.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_initHook() {
  return initHook;
}
var initHook;
function initHook$init$() {
  CryptographySystem_getInstance().registerProvider_gzjt6_k$(get_defaultProvider(), 100);
  return Unit_instance;
}
//region block: eager init
initHook = initHook$init$();
//endregion
//region block: exports
export {
  get_initHook as get_initHook1mpoljvw7lspf,
};
//endregion

//# sourceMappingURL=WebCryptoCryptographyProvider.js.mjs.map
